module.exports = __webpack_public_path__ + "static/img/fish53.4616172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish53.png
// module id = cUID
// module chunks = 0